const initailState = {
  userId: "",
  imageId: "",
  celebId: "",
};

const bidPanel = (state = initailState, action) => {
  switch (action.type) {
    case "START_BIDDING":
      return action.value;
    case "STOP_BIDDING":
      return {
        userId: "",
        imageId: "",
        celebId: "",
      };
    default:
      return state;
  }
};

export default bidPanel;
